module.exports = __webpack_public_path__ + "static/media/mania_benefits_info.442ebe30.png";